import { Injectable } from '@angular/core';
import { Headers, Http, URLSearchParams } from '@angular/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppConstants } from '../core/app.constants';
import { BaseResponse, ClientsResponse, Client} from "../core/core.component";

@Injectable()
export class ClientService {
    
    constructor(private http: Http) { }
    
    getClients(srmToken : string, onlyActive: boolean): Observable<ClientsResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/clients";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        params.set("onlyActive", onlyActive.toString());
        
        return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
    }
    
    insertClient(srmToken, client: Client): Observable<BaseResponse> 
    {
        var url = environment.REST_SERVICE_BASE_URL + "/clients/insert";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let body = {
                cdc: client.cdc,
                email:client.email,
                descrizione_cliente:client.dscliente,
                referente: client.referente
        };
        return this.http.post(url, body, {headers: headers}).map((responseData) => responseData.json());
    }

    updateClient(srmToken, client: Client): Observable<BaseResponse> 
        {
            var url = environment.REST_SERVICE_BASE_URL + '/clients/update/'+ client.idcliente;
            url = AppConstants.urlForNoCache(url);
            var headers = new Headers();
            headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
            let body = {
                descrizione_cliente: client.dscliente,
                cdc: client.cdc,
                email:client.email,
                referente: client.referente
            };
            return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
    }

    deleteClient(srmToken, id: number): Observable<BaseResponse> {
            let url = environment.REST_SERVICE_BASE_URL + '/clients/delete/' + id;
            url = AppConstants.urlForNoCache(url);
            const headers = new Headers();
            headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
            return this.http.delete(url, {headers: headers}).map((responseData) => responseData.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/service/clients.service.ts